import axios from "axios";
import config from "../config";
import { SF_COOKIE_ACCESS_TOKEN } from "@/modules/auth/persistence/constants";

let client = axios.create({
  baseURL: config.get("OYF_API_URL")
});

client.interceptors.request.use(
  function(config) {
    // before each client request, we'll check for an auth token
    // and add it to the request header if present
    let accessToken = getAccessToken();
    accessToken
      ? (config.headers.Authorization = "Bearer " + accessToken)
      : delete config.headers.Authorization;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

function checkAndParseResponse(json) {
  let res = json.data;
  if (res.meta.code >= 200 && res.meta.code < 300) {
    return json.data;
  } else {
    var error = res.meta || "unknown error";
    throw error;
  }
}

/*
  This function handles an error thrown by axios.
  In 95% of cases it returns a new error type, httpStatusException,
  which gives the original callee the option to
  process the http status code and error message returned
  by the API.
 */
function parseAxiosError(axiosError) {
  if (axiosError.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // This is the 95% scenario
    const httpStatus = axiosError.response.status;
    let message;
    let error_type;
    if (axiosError.response.data && axiosError.response.data.meta) {
      if (axiosError.response.data.meta.message) {
        message = axiosError.response.data.meta.message;
      }
      if (axiosError.response.data.meta.error_type) {
        error_type = axiosError.response.data.meta.error_type;
      }
    }
    // return a new exception object so the original callee
    // has a better chance of handling the failure
    throw new httpStatusException(message, httpStatus, error_type);
  } else if (axiosError.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest
    throw new httpStatusException("No server response", 408);
  } else {
    // Something happened in setting up the request that triggered an Error
    let message = axiosError.message || "Unknown error submitting API request";
    throw new Error(message);
  }
}

function httpStatusException(message, httpCode = 500, errorType = null) {
  this.httpCode = httpCode;
  this.message = message;
  this.errorType = errorType;
}

function getAccessToken() {
  // we store the current access token in session storage, since:
  // a) it expires automatically
  // b) it is unique per browser session
  return sessionStorage.getItem(SF_COOKIE_ACCESS_TOKEN);
}

export {
  client,
  checkAndParseResponse,
  httpStatusException,
  parseAxiosError,
  getAccessToken
};
